import { ListIcon, ListItem } from '@chakra-ui/react'
import React, { ComponentProps, useContext, FC, ReactNode } from 'react'
import { useColor } from '../../theme'
import { HeaderPopoverContext } from './HeaderPopover'
import { ICON_SIZE } from './constants'

interface IHeaderPopoverFeedbackListItemProps {
  dataTestId?: string
  icon?: ComponentProps<typeof ListIcon>['as']
  id?: string
  content: ReactNode
}
/**
 * List item feedback for the popover list in the header menu.
 *
 * To show feedback to the user, different color from the regular list item.
 */
export const HeaderPopoverFeedbackListItem: FC<IHeaderPopoverFeedbackListItemProps> = ({ icon, dataTestId, content, id }) => {
  const backgroundColor = useColor({ nuance: 8, palette: 'secondary' })
  const color = useColor({ nuance: 'white', palette: 'colors' })

  const { forceClose } = useContext(HeaderPopoverContext)

  return (
    <ListItem
      alignItems="center"
      as="button"
      backgroundColor={backgroundColor}
      borderRadius="lg"
      color={color}
      cursor="default"
      data-testid={dataTestId ?? `header-popover-feedback-list-item`}
      display="flex"
      fontSize="md"
      fontWeight="600"
      h={10}
      id={id}
      justifyContent="space-between"
      onClick={forceClose}
      px={2}
      w="full">
      {content}

      {icon && (
        <ListIcon
          as={icon}
          color={color}
          fontSize={ICON_SIZE}
          marginInlineEnd={0}
        />
      )}
    </ListItem>
  )
}
